// src/ScrollToTop.js — Bouton retour haut de page flottant
import React, { useState, useEffect } from 'react';

const ScrollToTop = ({ scrollContainer = null }) => {
  const [visible, setVisible] = useState(false);
  const [scrollPct, setScrollPct] = useState(0);

  useEffect(() => {
    const el = scrollContainer ? document.querySelector(scrollContainer) : window;
    if (!el) return;

    const onScroll = () => {
      const scrollTop = scrollContainer ? el.scrollTop : window.scrollY;
      const scrollHeight = scrollContainer
        ? el.scrollHeight - el.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      const pct = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setScrollPct(Math.round(pct));
      setVisible(scrollTop > 300);
    };

    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, [scrollContainer]);

  const scrollTop = () => {
    const el = scrollContainer ? document.querySelector(scrollContainer) : window;
    if (!el) return;
    if (scrollContainer) el.scrollTo({ top: 0, behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  // Cercle SVG progress
  const r = 20;
  const circ = 2 * Math.PI * r;
  const dash = (scrollPct / 100) * circ;

  return (
    <div
      onClick={scrollTop}
      title="Retour en haut"
      style={{
        position: 'fixed',
        bottom: '28px',
        right: '28px',
        width: '52px',
        height: '52px',
        cursor: 'pointer',
        zIndex: 9999,
        animation: 'fadeSlideIn 0.25s ease',
        filter: 'drop-shadow(0 4px 12px rgba(30,64,175,0.35))',
      }}
    >
      <style>{`
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .stt-btn:hover .stt-circle { filter: brightness(1.15); }
        .stt-btn:hover .stt-arrow  { transform: translateY(-2px); }
        .stt-arrow { transition: transform 0.2s ease; }
      `}</style>

      <div className="stt-btn" style={{ position: 'relative', width: '52px', height: '52px' }}>
        {/* Fond cercle */}
        <svg width="52" height="52" style={{ position: 'absolute', top: 0, left: 0 }}>
          {/* Fond */}
          <circle cx="26" cy="26" r={r} fill="url(#sttGrad)" />
          {/* Progress arc */}
          <circle
            cx="26" cy="26" r={r}
            fill="none"
            stroke="rgba(255,255,255,0.35)"
            strokeWidth="3"
            strokeDasharray={`${dash} ${circ}`}
            strokeLinecap="round"
            transform="rotate(-90 26 26)"
          />
          <defs>
            <linearGradient id="sttGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#1e40af" />
              <stop offset="100%" stopColor="#3b82f6" />
            </linearGradient>
          </defs>
        </svg>

        {/* Flèche + label */}
        <div className="stt-arrow" style={{
          position: 'absolute', inset: 0,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: '1px',
        }}>
          <svg width="14" height="10" viewBox="0 0 14 10">
            <polyline points="1,8 7,2 13,8" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={{ color: 'white', fontSize: '8px', fontWeight: 700, letterSpacing: '0.03em' }}>TOP</span>
        </div>
      </div>
    </div>
  );
};

export default ScrollToTop;
